
import { ComparisonState } from './types';
import { translations } from './translations';

const defaultLang = 'fr';
const t = translations[defaultLang];

export const INITIAL_STATE: ComparisonState = {
  beforeImage: 'https://images.unsplash.com/photo-1510797215324-95aa89f43c33?auto=format&fit=crop&w=1200&q=80',
  afterImage: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80',
  title: t.default_title,
  beforeLabel: t.default_before_label,
  afterLabel: t.default_after_label,
  beforeDesc: t.default_before_desc,
  afterDesc: t.default_after_desc,
  orientation: 'horizontal',
  viewMode: 'slider',
  splitPosition: 50,
  separatorColor: '#6366f1',
  separatorWidth: 4,
  beforeLabelPos: { x: 15, y: 15 },
  afterLabelPos: { x: 85, y: 85 },
  beforeLabelSize: { width: 220, height: 120 },
  afterLabelSize: { width: 220, height: 120 },
  objectFit: 'cover',
  fontFamily: 'Inter',
  fontSize: 16,
  accentColor: '#6366f1',
  bgColor: '#0f172a',
  theme: 'default',
  borderRadius: 24,
  padding: 10,
  language: defaultLang,
  labelColor: '#ffffff',
  descColor: '#f8fafc',
  exportMode: 'image'
};

export const FONTS_LIST = [
  'Inter',
  'Roboto Mono',
  'Unbounded',
  'Space Grotesk'
];